var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.jobStages && _vm.jobStages.length > 0
    ? _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-6" }, [
          _c(
            "article",
            { staticClass: "box" },
            [
              _c("p", { staticClass: "title" }, [_vm._v("Totals")]),
              !_vm.value.isAssessmentEnabled
                ? _c("quote-detail-summary", {
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  })
                : _c("quote-detail-assessment-summary", {
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  }),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }